'use strict'
require('core-js/modules/es.date.to-string')
require('core-js/modules/es.object.assign')
exports.__esModule = true
exports.getNow = getNow
exports.get = get
exports.getHmsFromDate = getHmsFromDate
exports.getHmsFromDateAsStr = getHmsFromDateAsStr
exports.getDmyFromDate = getDmyFromDate
exports.getObjDateFromDate = getObjDateFromDate
exports.getDateFromStr = getDateFromStr
exports.default = void 0

var _is = require('../is')
var _fmt = require('./fmt')
var _consts = require('./consts')

/**
 * getNow
 * Возвращает дату с текущим временем в нулевой временной зоне
 *
 * @example
 * // now is 17:00
 * const d = new Date() // 2018-06-06T14:00:00.612Z
 * d.getHours() // 17
 * d.getUTCHours() // 14
 * getNow().getUTCHours() // 17
 * @returns {Date}
 * @memberof Time
 */
function getNow() {
  var d = new Date()
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
  d.setMilliseconds(0)
  return d
}

/**
 * get
 * Дублирует функционал Date.getUTC*
 *
 * @param {Date} d
 * @param {PartNameType} partName
 * @example
 * get( date, 'y' ) // 2018
 * get( date, 'd' ) // 31
 * @returns {number}
 * @memberof Time
 */
function get(d, partName) {
  switch (partName) {
    case 'y':
      return d.getUTCFullYear()
    case 'q': {
      var m = get(d, 'M') + 1
      return Math.ceil(m / 3) - 1
    }
    case 'M':
      return d.getUTCMonth()
    case 'w': {
      var onejan = new Date(d.getUTCFullYear(), 0, 1)
      var week = Math.ceil(((d - onejan) / _consts.ONE_DAY_MS + onejan.getDay() + 1) / 7)
      return week
    }
    case 'd':
      return d.getUTCDate()
    case 'D':
      return d.getUTCDay()
    case 'h':
      return d.getUTCHours()
    case 'm':
      return d.getUTCMinutes()
    case 's':
      return d.getUTCSeconds()
    case 'ms':
      return d.getUTCMilliseconds()
    default:
      throw new Error('unknown time part name: ' + partName)
  }
}

/**
 * getHmsFromDate
 * Возвращает объект с часами, минутами, секундами из переданной даты
 *
 * @param {Date} d
 * @example
 * getHmsFromDate( date )
 * // {
 * //   h: 13,
 * //   m: 45
 * //   s: 59
 * // }
 * @returns {ObjHmsType}
 * @memberof Time
 */
function getHmsFromDate(d) {
  return {
    h: get(d, 'h'),
    m: get(d, 'm'),
    s: get(d, 's')
  }
}

function getHmsFromDateAsStr(d) {
  return {
    h: (0, _fmt.toTensStr)(get(d, 'h')),
    m: (0, _fmt.toTensStr)(get(d, 'm')),
    s: (0, _fmt.toTensStr)(get(d, 's'))
  }
}

/**
 * getDmyFromDate
 * Возвращает объект с числом, месяцем, годом из переданной даты
 *
 * @param {Date} d
 * @example
 * getDmyFromDate( date )
 * // {
 * //   d: 13,
 * //   M: 0
 * //   y: 2021
 * // }
 * @returns {ObjDmyType}
 * @memberof Time
 */
function getDmyFromDate(d) {
  return {
    d: get(d, 'd'),
    M: get(d, 'M'),
    y: get(d, 'y')
  }
}

/**
 * getObjDateFromDate
 * Возвращает дату в виде объекта
 *
 * @param {Date} d
 * @example
 * getObjDateFromDate( date )
 * // {
 * //   y: 2018,
 * //   M: 1,
 * //   d: 28,
 * //   h: 13,
 * //   m: 45
 * //   s: 59
 * // }
 * @returns {ObjHmsType}
 * @memberof Time
 */
function getObjDateFromDate(d) {
  return Object.assign({}, getDmyFromDate(d), getHmsFromDate(d))
}

/**
 * getDateFromStr
 * Конвертирует строку в Date
 *
 * @param {string} dateStr
 * @example
 * convertFromStr( '2018-06-09T15:15:14.048Z' ) // Date
 * convertFromStr( 'qwe' ) // null
 * @returns {(Date | null)}
 * @memberof Time
 */
function getDateFromStr(dateStr) {
  var d = new Date(dateStr)
  return (0, _is.isNum)(d.getTime()) ? d : null
}

var getters = {
  get: get,
  now: getNow,
  hmsFromDate: getHmsFromDate,
  hmsFromDateAsStr: getHmsFromDateAsStr,
  dmyFromDate: getDmyFromDate,
  dateObjFromDate: getObjDateFromDate,
  dateFromStr: getDateFromStr
}
var _default = getters
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/getters.js
// module id = 78
// module chunks = 0